import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import { GradientButtonV2 } from '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import { WithCustomScrollbar } from '../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const WalletTabs = ({
  activeTabIDX,
  onTabChange,
  isCategorySelected,
  currentForm,
  tabs = [],
  panels = [],
  className,
  style
}) => {
  const [activeIdx, setActiveIdx] = useState(0);
  useEffect(() => {
    setActiveIdx(activeTabIDX);
  }, [activeTabIDX]);
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.left, {
        [styles.visible]: isCategorySelected
      })
    },
    currentForm
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.right, {
        [styles.visible]: !isCategorySelected
      })
    },
    /* @__PURE__ */ React.createElement(
      Tabs,
      {
        className: styles.tabs,
        defaultIndex: activeIdx,
        forceRenderTabPanel: true,
        onSelect: (v) => {
          setActiveIdx(v);
          onTabChange(v);
        }
      },
      /* @__PURE__ */ React.createElement(TabList, { className: styles.tabs__list }, tabs.map((item, i) => /* @__PURE__ */ React.createElement(
        Tab,
        {
          className: cx(styles.tab, {
            [styles.active]: activeIdx === i
          }),
          key: i
        },
        /* @__PURE__ */ React.createElement(
          GradientButtonV2,
          {
            name: item.name,
            active: activeIdx === i,
            onClick: () => {
              setActiveIdx(i);
            }
          }
        )
      ))),
      panels.map((item, i) => /* @__PURE__ */ React.createElement(
        TabPanel,
        {
          className: cx(styles.panel, {
            [styles.visible]: activeIdx === i
          }),
          key: i
        },
        /* @__PURE__ */ React.createElement(
          WithCustomScrollbar,
          {
            className: cx(styles["scroll-tabs-container"])
          },
          item
        )
      ))
    )
  ));
};
WalletTabs.displayName = "Wallet.WalletTabs";

export { WalletTabs };
//# sourceMappingURL=index.js.map
